import service from "@/service.js";

const getInitialState = () => {
  return {
    news: [
      {
        chinese_context: "官方留言",
        chinese_content:
          "任何版本更新、系统崩溃或恢复等情况，会在最新公告中通知。如有问题可以及时联系我们，我们会在最新公告中反馈。我们会在最新公告中提供系统使用高峰时段信息，以及何时系统运行更快速和稳定。",
        english_context: "Official message",
        english_content:
          "Any version updates, system crashes, or recoveries will be announced in the latest notice. If you have any issues, please contact us promptly, and we will provide feedback in the latest announcement. We will provide information about peak usage hours and when the system runs faster and more stable.",
        date: "2025-03-06",
        id: 0,
        status: "error",
      },
    ],
  };
};

const state = getInitialState();

const getters = {
  news(state) {
    return state.news;
  },
};

const mutations = {
  createNews(state, { news }) {
    state.news = news;
  },
  dropNews(state) {
    state.news = [];
  },
  insertNews(state, { news }) {
    state.news.push(news);
  },
};

function isValidNews(news) {
  return (
    news &&
    typeof news === "object" &&
    typeof news.chinese_context === "string" &&
    typeof news.chinese_content === "string" &&
    typeof news.english_context === "string" &&
    typeof news.english_content === "string" &&
    typeof news.date === "string" &&
    typeof news.id === "number" &&
    typeof news.status === "string"
  );
}

const actions = {
  async FetchNews({ commit }) {
    try {
      const response = await service({
        url: "/api/news",
        method: "get",
      });
      const news = response.data;
      news.sort((a,b)=>new Date(b.date) - new Date(a.date))
      const cutoffDate = new Date('2025-03-27');
      news.filter(item=>new Date(item.date)>=cutoffDate).forEach((news) => {
        if (isValidNews(news) && !state.news.some((n) => n.id === news.id)) {
          commit("insertNews", { news });
        }
      });
    } catch (error) {
      console.error("Error fetching news:", error);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
